import script from "./AsideForTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideForTerms.vue?vue&type=script&setup=true&lang=js"

import "./AsideForTerms.vue?vue&type=style&index=0&id=b3c96c96&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3c96c96"]])

export default __exports__